require "signature-pad/jquery.signaturepad.js"

define [], () ->
  (RentappService, $state, $uibModal, $timeout) ->
    restrict: "E"
    template: require("./signature.jade")
    scope: { field: "=", mode: "@", stage: "="}
    link: (scope, element, attrs) ->
      $timeout () ->
        $element = $(element)
        $canvas = $element.find("canvas")
        $canvas.attr "width",  $canvas.innerWidth()
        $canvas.attr "height", $canvas.innerHeight()
        $sigPadEl = $element.find(".sigPad")

        if scope.mode == "view"
          sigPad = $sigPadEl.signaturePad
            displayOnly: true
        else
          sigPad = $sigPadEl.signaturePad
            displayOnly: false
            defaultAction: "drawIt"
            drawBezierCurves: true
            variableStrokeWidth: true
            lineTop: 110
            onDrawEnd: () ->
              scope.$apply () =>
                scope.field.value = this.getSignatureString()

        scope.$watch "field.value", (newValue) ->
          try
            if newValue and newValue.length > 2
              if newValue[0] == "[" && newValue[1] == "{"
                sigPad.regenerate(newValue )
            else
                sigPad.regenerate([])
          catch e
            console.trace "signature problem", newValue, e



// WEBPACK FOOTER //
// ./directives/freeforms/signature/signature.coffee